import { PermissionCheckerService } from '@abp/auth/permission-checker.service';
import { Injector, ElementRef, Component, OnInit, ViewEncapsulation, Inject, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppMenu } from './app-menu';
import { AppNavigationService } from './app-navigation.service';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuOptions } from '@metronic/app/core/_base/layout/directives/menu.directive';
import { ThemesLayoutBaseComponent } from '../themes/themes-layout-base.component';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { ImpersonationService } from '@app/admin/users/impersonation.service';
import { AbpSessionService } from '@abp/session/abp-session.service';
import { EmployeesServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';
@Component({
    templateUrl: './side-bar-menu.component.html',
    selector: 'side-bar-menu',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideBarMenuComponent extends AppComponentBase implements OnInit {

    menu: AppMenu = null;
    currentActiveMenuItem: any = null; // To track the active menu item
    currentActiveParentItem: any = null;
    currentRouteUrl = '';
    insideTm: any;
    outsideTm: any;
    name: string = ''; 
    userImage:string = '';
    designation: string = '';
    menuOptions: MenuOptions = {
        // vertical scroll
        scroll: null,

        // submenu setup
        submenu: {
            desktop: {
                default: 'dropdown',
                state: {
                    body: 'kt-aside--minimize',
                    mode: 'dropdown'
                }
            },
            tablet: 'accordion', // menu set to accordion in tablet mode
            mobile: 'accordion' // menu set to accordion in mobile mode
        },

        // accordion setup
        accordion: {
            expandAll: false // allow having multiple expanded accordions in the menu
        }
    };
    isImpersonatedLogin: boolean;
    

    constructor(
        injector: Injector,
        private el: ElementRef,
        private router: Router,
        public permission: PermissionCheckerService,
        private _appNavigationService: AppNavigationService,
            private _authService: AppAuthService,
            private _employeesServiceProxy: EmployeesServiceProxy,

            private _impersonationService: ImpersonationService,
             private _abpSessionService: AbpSessionService,
        @Inject(DOCUMENT) private document: Document) {
        super(injector);
        
    }

    ngOnInit() {
        this.employeeValue();
        this.menu = this._appNavigationService.getMenu();
        this.isImpersonatedLogin = this._abpSessionService.impersonatorUserId > 0;
        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
  
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(event => {
                this.currentRouteUrl = this.router.url.split(/[?#]/)[0]
                this.hideSidebar();
            });

        console.log('router',this.router.url)    
    }
    hideSidebar() {
debugger;
        var isSidebarHidden = document.body.classList.contains("kt-aside--minimize")
        if(!isSidebarHidden){
            setTimeout(()=>{
                this.document.body.classList.add('kt-aside--minimize');
            },50);
        }
    
    }
    backToMyAccount(): void {
        this._impersonationService.backToImpersonator();
    }
    MyProfilePicture() {
        //
        this.router.navigateByUrl(`app/main/employee/viewemployee/${this.appSession.Employeeid}/ProfilePage/0`);

        //this.router.navigateByUrl('app/main/myprofileemployee/myprofileemployee/' + 0);
    }
    openSidebar(item) {
        if (item.items.length > 0) {
            this.currentActiveMenuItem = item;
            this.currentActiveParentItem = item; 
        } else {
            this.currentActiveParentItem = null;
        }
        setTimeout(()=>{
            this.document.body.classList.remove('kt-aside--minimize');
        },50);
    
    }

    showMenuItem(menuItem): boolean {
        return this._appNavigationService.showMenuItem(menuItem);
    }
    changePassword(): void {
        debugger;
        abp.event.trigger('app.show.changePasswordModal');
    }
    logout(): void {
    
        this._authService.logout();
    }
    isMenuItemIsActive(item): boolean {
        if (item.items.length) {
            return this.isMenuRootItemIsActive(item);
        }

        // if (!item.route) {
        //     return false;
        // }

        // dashboard
        if (item.route === this.currentRouteUrl || this.currentRouteUrl.startsWith(item.route)) {
            return true;
        }

        return this.currentRouteUrl.replace(/\/$/, '') === item.route.replace(/\/$/, '');
    }

    isMenuRootItemIsActive(item): boolean {
        let result = false;

        for (const subItem of item.items) {
            result = this.isMenuItemIsActive(subItem);
            if (result) {
                return true;
            }
        }

        return false;
    }
    employeeValue() {
        this._employeesServiceProxy.getCurrentLogIn().subscribe((result: string[]) => {
          debugger;
            if (result && result.length > 0) {
            this.designation = result[0];  
            this.name = result[1];  
            this.userImage =this.getURLImage(result[2]);
          }
        });
      }
    /**
	 * Use for fixed left aside menu, to show menu on mouseenter event.
	 * @param e Event
	 */
    mouseEnter(e: Event) {
        if (!this.currentTheme.baseSettings.menu.allowAsideMinimizing) {
            return;
        }

        // check if the left aside menu is fixed
        if (this.document.body.classList.contains('m-aside-left--fixed')) {
            if (this.outsideTm) {
                clearTimeout(this.outsideTm);
                this.outsideTm = null;
            }

            this.insideTm = setTimeout(() => {
                // if the left aside menu is minimized
                if (this.document.body.classList.contains('m-aside-left--minimize') && KTUtil.isInResponsiveRange('desktop')) {
                    // show the left aside menu
                    this.document.body.classList.remove('m-aside-left--minimize');
                    this.document.body.classList.add('m-aside-left--minimize-hover');
                }
            }, 300);
        }
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseLeave(e: Event) {
        if (!this.currentTheme.baseSettings.menu.allowAsideMinimizing) {
            return;
        }

        if (this.document.body.classList.contains('m-aside-left--fixed')) {
            if (this.insideTm) {
                clearTimeout(this.insideTm);
                this.insideTm = null;
            }

            this.outsideTm = setTimeout(() => {
                // if the left aside menu is expand
                if (this.document.body.classList.contains('m-aside-left--minimize-hover') && KTUtil.isInResponsiveRange('desktop')) {
                    // hide back the left aside menu
                    this.document.body.classList.remove('m-aside-left--minimize-hover');
                    this.document.body.classList.add('m-aside-left--minimize');
                }
            }, 500);
        }
    }

    getURLImage(url: string) {
            if (url.startsWith('data:')) {
                return url;
            }
            return AppConsts.ftpUrl + '/' + url
        }
}
